import React from "react";
import Application from "./components/Application";

const App = () => {
  return (
    <div className="App">
      <Application />
    </div>
  );
};

export default App;
